var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-h-center",on:{"click":_vm.sort}},[_vm._t("default"),_c('span',{staticClass:"caret-wrapper flex flex-h-center",class:this.orderBy === this.prop?[_vm.val]:[]},[_c('i',{staticClass:"sort-caret asc"}),_c('i',{staticClass:"sort-caret desc"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }